// Translation: Verification > Landing > Form (Arabic)
export default Object.freeze({
	form: {
		actions: {
			verifyAccount: 'تحقق من الحساب'
		},
		fields: {
			code: {
				placeholder: 'أدخل رمز التأكيد'
			}
		},
		options: {
			resendCode: {
				label: {
					idle: 'إعادة إرسال الرمز',
					success: '!تم الإرسال'
				}
			}
		},
		title: 'تأكيد الحساب'
	}
})
